import { TabButtons } from '@analytical-alley/ui';

import { useModelVsActual } from '@/dashboards/TitleDashboard/hooks';
import { capitalizeFirstLetter } from '@/utils/stringUtils';
import { transformWeeklyToMonthlyModelVsActual } from '@/utils/weeklyToMonthlyUtils';

import { WithLoader } from '@/components/WithLoader';

import { useMemo } from 'react';
import { ModelVsActualGraph } from '../components/ModelVsActualGraph';

export const ModelVsActual = () => {
    const {
        queryResult: { data: modelVsActualData, isLoading, isFetching },
        activeTabIndex,
        availablePeriodOptions,
        getMouseHandlers,
        onActiveTabChange,
    } = useModelVsActual();

    const transformedData = useMemo(
        () => transformWeeklyToMonthlyModelVsActual(modelVsActualData),
        [modelVsActualData],
    );

    const residual = useMemo(() => {
        return {
            maxResidual: transformedData?.maxResidual || 0,
            minResidual: transformedData?.minResidual || 0,
            colors: {
                onlyPositive: {
                    max: '#02793c',
                    min: '#8bd7af',
                },
                onlyNegative: {
                    max: '#F93C5E',
                    min: '#b40424',
                },
                both: {
                    max: '#73EFAC',
                    min: '#F93C5E',
                },
            },
        };
    }, [transformedData?.maxResidual, transformedData?.minResidual]);

    return (
        <div className="flex flex-col relative">
            <TabButtons
                aria-label="Periodicity"
                variant="pills"
                className="gap-2 max-[1858px]:mt-2 px-2 relative top-4"
                onActiveTabChange={onActiveTabChange}
                isLoading={isLoading}
                activeTab={activeTabIndex}
            >
                {availablePeriodOptions?.map((periodName) => {
                    return (
                        <TabButtons.Item
                            {...getMouseHandlers(periodName)}
                            key={periodName}
                            title={capitalizeFirstLetter(periodName)}
                            disabled={isLoading}
                        />
                    );
                })}
            </TabButtons>
            <WithLoader
                className="glass-tile relative backdrop-filter-none min-h-80 pl-6 pt-2 flex text-base rounded-2xl max-lg:max-w-full"
                isLoading={isLoading}
                isFetching={isFetching}
            >
                <ModelVsActualGraph
                    isLoading={isLoading}
                    className={isFetching ? 'opacity-50' : 'min-h-80'}
                    residual={residual}
                    data={transformedData}
                />
            </WithLoader>
        </div>
    );
};
